import React from 'react';
import Card from 'src/components/atomic/atoms/card/Card';
import WideView from 'src/components/atomic/layouts/wideView/WideView';
import LiteralsService from 'src/services/literals/LiteralsService';
import { useDocumentTitleRaw } from 'src/hooks/useDocumentTitle';
import { useTrackPage } from 'src/hooks/useAdobeTags';
import Selectors from 'src/utils/selectors';
import ManageRulesHeader from 'src/components/atomic/organisms/manageRulesHeader/ManageRulesHeader';
import DragAndDropRulesWrapper from 'src/components/atomic/organisms/dragAndDropRules/DragAndDropRules';
import RuleSettingWrapper from 'src/components/atomic/molecules/ruleSetting/RuleSetting';
import { useFeatureFlag } from 'src/hooks/queries/one-xp';
import oneXp from 'src/types/one-xp';
import Divider from 'src/components/atomic/atoms/divider/Divider';
import styles from './manageRulesView.module.scss';

export default function ManageRulesView(): JSX.Element {
    useDocumentTitleRaw(LiteralsService.getLiteral('Budget.titles.transactionRules'));
    useTrackPage(LiteralsService.getLiteral('Budget.titles.transactionRules'));
    const { data: transactionsContextualRulesFeatureFlag } = useFeatureFlag(
        oneXp.FeatureFlags.TransactionsContextualRules
    );

    return (
        <WideView
            withDocTitle={false}
            hasBackgroundBanner
            showFooter
            title={LiteralsService.getLiteral('ManageRulesView.title')}
            subtitle={LiteralsService.getLiteral('ManageRulesView.subtitle')}
            data-cy={Selectors.Transactions.RULE_VIEW}
            hideBackButton
        >
            <Card showBackgroundBanner>
                <ManageRulesHeader />
                <DragAndDropRulesWrapper />
                {transactionsContextualRulesFeatureFlag && (
                    <>
                        <Divider className={styles.ruleSettingMargin} color="weak" />
                        <RuleSettingWrapper />
                    </>
                )}
            </Card>
        </WideView>
    );
}
